import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Button, Text, Spinner, Toggle, Icon, Radio, CheckBox } from '@ui-kitten/components'
import Divider from './Divider'
import { PaymentMethodsSelect } from './PaymentMethodsSelect'
import { PurchaseMethodsSelect } from './PurchaseMethodsSelect'
import { ChangeView } from './ChangeView'
import StyledTextInput from './StyledTextInput'
import PlatformDependantSelect from './PlatformDependantSelect'
import { finalTotalCartPrice } from './CartView'
import { updatePrintChecks } from '../global/Firebase/firebase'
import { useTranslation } from 'react-i18next'
import { isCartEmptyForCheckout } from '../utils/checkoutBlocked'

export const PaymentView = React.memo(({purchaseMethod, setPurchaseMethod, purchaseMethods, paymentMethod,  
  setPaymentMethod, paymentMethods, mixedPayment, setMixedPayment, firstPaymentValue, setFirstPaymentValue, 
  secondPaymentMethod, setSecondPaymentMethod, postPaid, setPostPaid, printChecks, setPrintChecks, 
  client, saveError, isLoading, submit, checkoutStyle, cartItems, discountOptions, discountSelectedIndex, discountAmount,
  db, saveCart, setPaymentModalVisible, bonusAction, loyaltySettings, delivery, setDelivery, deliveryPrice, setDeliveryPrice, 
  deliveryPaidByCustomer, setDeliveryPaidByCustomer, deliveryIncludeInReceipt, setDeliveryIncludeInReceipt, deliveryAddress, 
  setDeliveryAddress, deliveryPaymentSourceWallet, setDeliveryPaymentSourceWallet, wallets, store, setCartItems, currencyFormatter,
  selectedPriceType, priceTypes
}) => {
  const { t } = useTranslation()
  const storeWallets = wallets?.filter(wallet => !wallet.storeId || wallet.storeId === store)
  const priceTypeId = selectedPriceType?.id || null
  return (
    <View key='paymentView'>
      <PurchaseMethodsSelect purchaseMethod={purchaseMethod} setPurchaseMethod={setPurchaseMethod} purchaseMethods={purchaseMethods} store={store} />
      <Divider />
      { mixedPayment && <Text category='label' style={{marginBottom: 5}}>{t('newSale.firstPaymentMethodAndValue')}</Text>}
      { !postPaid && (
        <PaymentMethodsSelect paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} paymentMethods={paymentMethods} style={{marginBottom: 5}} store={store} />
      )}
      { mixedPayment && (
        <View key='mixedPayment'>
          <StyledTextInput
            key='firstPaymentValue'
            value={firstPaymentValue}
            onChangeText={text => setFirstPaymentValue(text.replace(/,/g, '.'))}
            keyboardType='decimal-pad'
            style={{marginBottom: 5}}
            returnKeyType='done'
            placeholder={t('newSale.firstPaymentValue')}
          />
          <Text category='label' style={styles.label}>{t('newSale.secondPaymentMethodAndValue')}</Text>
          <PaymentMethodsSelect paymentMethod={secondPaymentMethod} setPaymentMethod={setSecondPaymentMethod} paymentMethods={paymentMethods} style={{marginBottom: 5}} store={store} />
          <Text category='s2' style={{marginTop: 5}}>{t('newSale.secondSum') + ': ' + (currencyFormatter.format((finalTotalCartPrice(discountOptions[discountSelectedIndex]?.percentage, discountAmount, cartItems, store, client, bonusAction, loyaltySettings?.cashbackEnabled, loyaltySettings?.punchCardEnabled, loyaltySettings?.punchCardCapacity, purchaseMethod?.priceModificators, priceTypeId, priceTypes) - parseFloat(firstPaymentValue)) || 0))}</Text>
          <Divider />
        </View>
      )}
      {paymentMethod?.isCash == true && !mixedPayment && (
        <ChangeView style={{marginTop: 10}} cartItems={cartItems} discountOptions={discountOptions} discountSelectedIndex={discountSelectedIndex} discountAmount={discountAmount} store={store} client={client} bonusAction={bonusAction} cashbackEnabled={loyaltySettings?.cashbackEnabled} punchCardEnabled={loyaltySettings?.punchCardEnabled} punchCardCapacity={loyaltySettings?.punchCardCapacity} priceModificators={purchaseMethod?.priceModificators} selectedPriceType={selectedPriceType} priceTypes={priceTypes} />
      )}
      { delivery && (
        <View>
          { !mixedPayment && <Divider /> }
          <Text category='label' style={{marginTop: 5, marginBottom: 5}}>{t('newSale.delivery')}</Text>
          <Radio style={{marginBottom: 5}} checked={deliveryPaidByCustomer===true} onChange={(checked) => {
            setDeliveryPaidByCustomer(true)
            if (deliveryIncludeInReceipt) {
              let numberAmount = parseFloat(deliveryPrice)
              setCartItems(cartItems => {
                const newCartItems = [...cartItems]
                const index = newCartItems.findIndex(item => item.id === 'delivery');
                if (index !== -1) {
                  newCartItems.splice(index, 1, {
                    id: 'delivery',
                    name: t('newSale.delivery'),
                    categoryID: 'delivery',
                    supplierID: 'delivery',
                    purchasePrice: numberAmount,
                    salePrices: {[store]: numberAmount},
                    quantity: 1,
                    activeInStore: {[store]: true}
                  })
                }
                return newCartItems
              })
            }
          }}>
            {t('newSale.deliveryPaidByCustomer')}
          </Radio>
          <Radio style={{marginBottom: 5}} checked={deliveryPaidByCustomer===false} onChange={(checked) => {
            setDeliveryPaidByCustomer(false)
            if (deliveryIncludeInReceipt) {
              let numberAmount = parseFloat(deliveryPrice)
              setCartItems(cartItems => {
                const newCartItems = [...cartItems]
                const index = newCartItems.findIndex(item => item.id === 'delivery');
                if (index !== -1) {
                  newCartItems.splice(index, 1, {
                    id: 'delivery',
                    name: t('newSale.delivery'),
                    categoryID: 'delivery',
                    supplierID: 'delivery',
                    purchasePrice: numberAmount,
                    salePrices: {[store]: 0},
                    quantity: 1,
                    activeInStore: {[store]: true}
                  })
                }
                return newCartItems
              })
            }
          }}>
            {t('newSale.deliveryPaidBySeller')}
          </Radio>
          { deliveryPaidByCustomer === false && (
            <>
              <Text category='label' style={styles.label}>{t('newSale.deliveryPaymentSourceWallet')}</Text>
              <PlatformDependantSelect
                data={storeWallets}
                selectedOption={deliveryPaymentSourceWallet}
                onSelect={(itemValue, itemIndex) => {
                  setDeliveryPaymentSourceWallet(itemValue)
                }}
                style={{marginBottom: 5}}
              />
            </>
          )}
          <Text category='label' style={styles.label}>{t('newSale.deliveryPrice')}</Text>
          <StyledTextInput
            key='deliveryPrice'
            value={deliveryPrice}
            onChangeText={text => setDeliveryPrice(text.replace(/,/g, '.'))}
            keyboardType='decimal-pad'
            style={{marginBottom: 5}}
            returnKeyType='done'
            testID="delivery-price-input"
          />
          <Text category='label' style={styles.label}>{t('newSale.deliveryAddress')}</Text>
          <StyledTextInput
            key='deliveryAddress'
            value={deliveryAddress}
            onChangeText={text => setDeliveryAddress(text)}
            controlledInput={true}
            style={{marginBottom: 5}}
            returnKeyType='done'
            testID="delivery-address-input"
          />
          <CheckBox style={{marginTop: 10, marginBottom: 5}} checked={deliveryIncludeInReceipt===true} onChange={(checked) => {
            setDeliveryIncludeInReceipt(checked)
            if (checked) {
              let numberAmount = parseFloat(deliveryPrice)
              setCartItems(cartItems => {
                let newCartItems = [...cartItems]
                newCartItems.push({
                  id: 'delivery',
                  name: t('newSale.delivery'),
                  categoryID: 'delivery',
                  supplierID: 'delivery',
                  purchasePrice: numberAmount,
                  salePrices: {[store]: deliveryPaidByCustomer ? numberAmount : 0},
                  quantity: 1,
                  activeInStore: {[store]: true}
                })
                return newCartItems
              })
            } else {
              setCartItems(cartItems => {
                const newCartItems = [...cartItems]
                const index = newCartItems.findIndex(item => item.id === 'delivery');
                if (index !== -1) {
                  newCartItems.splice(index, 1);
                }
                return newCartItems
              })
            }
          }}>
            {t('newSale.deliveryIncludeInReceipt')}
          </CheckBox>
          <Divider />
        </View>
      )}
      <View style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', marginTop: 10}}>
        <Toggle 
          checked={printChecks}
          onChange={(value) => {
            setPrintChecks(value)
            updatePrintChecks(db, value)
          }}
          style={styles.toggleField}
        >
          {t('newSale.printCheck')}
        </Toggle>
        <Toggle
          checked={mixedPayment}
          onChange={(value) => {
            setMixedPayment(value)
            setPostPaid(false)
          }}
          style={styles.toggleField}
          testID="mixed-payment-toggle"
        >
          {t('newSale.mixedPayment')}
        </Toggle>
        <Toggle
          checked={delivery}
          onChange={(value) => {
            setDelivery(value)
            if (value && deliveryIncludeInReceipt) {
              let numberAmount = parseFloat(deliveryPrice)
              if (isNaN(numberAmount)) numberAmount = 0
              setCartItems(cartItems => {
                const newCartItems = [...cartItems]
                const index = newCartItems.findIndex(item => item.id === 'delivery')
                if (index === -1) {
                  newCartItems.push({
                    id: 'delivery',
                    name: t('newSale.delivery'),
                    categoryID: 'delivery',
                    supplierID: 'delivery',
                    purchasePrice: deliveryPaidByCustomer ? numberAmount : 0,
                    salePrices: {[store]: deliveryPaidByCustomer ? numberAmount : 0},
                    quantity: 1,
                    activeInStore: {[store]: true},
                  })
                }
                return newCartItems
              })
            }
            if (!value) {
              setCartItems(cartItems => cartItems.filter(item => item.id !== 'delivery'))
            }
          }}
          style={styles.toggleField}
          testID="delivery-toggle"
        >
          {t('newSale.delivery')}
        </Toggle>
        { client?.clientType === 'b2b' &&
          <Toggle
            checked={postPaid}
            onChange={(value) => {
              setPostPaid(value)
              setMixedPayment(false)
            }}
            style={styles.toggleField}
            testID="post-paid-toggle"
          >
            {t('newSale.postPayment')}
          </Toggle>
        }
      </View>
      { checkoutStyle == 2 && (
        <>
          { saveError && (<Text style={{marginBottom: 5}} status='danger'>{saveError}</Text>) }
          { isLoading ? (
            <View style={styles.spinner}><Spinner /></View>
          ) : (
            <>
              <Button style={{marginBottom: 10, marginTop: 5}} appearance='outline' status='danger' onPress={() => setPaymentModalVisible(false)}>
                {t('cancel')}
              </Button>
              <View testID="save-cart-for-later-button">
                <Button style={{marginBottom: 10, marginTop: 5}} appearance='outline' accessoryLeft={(props) => (<Icon name='book-open-outline' {...props} />)} onPress={saveCart}>
                  {t('newSale.saveCartForLater')}
                </Button>
              </View>
              {/* ADS-FIX-2026-001: the modal only opens from a CTA that is disabled on an empty cart, so
                  this is belt-and-braces — the same predicate, so the two cannot disagree. */}
              {isCartEmptyForCheckout(cartItems) && (
                <Text style={{marginBottom: 5}} appearance='hint' testID="checkout-cart-empty-hint">
                  {t('newSale.addProductToCheckout')}
                </Text>
              )}
              <Button status='primary' style={styles.submitButton} onPress={submit} disabled={isCartEmptyForCheckout(cartItems)} testID="done-button">
                {t('done')}
              </Button>
            </>
          )}
        </>
      )}
    </View>
  )
})

PaymentView.displayName = 'PaymentView'

const styles = StyleSheet.create({
  label: {
    marginTop: 10,
    marginBottom: 5,
  },
  submitButton: {
    marginBottom: 40,
  },
  spinner: {
    marginTop: 15,
    marginBottom: 40,
    alignItems: 'center'
  },
  toggleField: {
    marginBottom: 10,
    alignSelf: 'flex-start'
  }
})

export default PaymentView


